import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@helder-nicollas/govbr-react-components/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers/sessionProvider.tsx");
